import jsonp from './jsonp.js'

export function getHomeData () {
  return new Promise(function (resolve, reject) {
    jsonp('http://weike.xdf.cn/Api/index/callback/jsonpCallback')
      .then(response => {
        resolve(response)
      }, err => {
        reject(err)
      })
  })
}

export function getMiddleData (channelId) {
  return new Promise(function (resolve, reject) {
    jsonp(`http://weike.xdf.cn/Api/xdfAds/channel_id/${channelId}/callback/jsonpCallback`)
      .then(response => {
        resolve(response)
      }, err => {
        reject(err)
      })
  })
}

export function getGobroadData () {
  return new Promise(function (resolve, reject) {
    jsonp('http://weike.xdf.cn/ChannelCourse/index', {
      channel: '留学'
    }).then(response => {
      resolve(response)
    }, err => {
      reject(err)
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/js/getLivingData.js